<span class="celum-chip_content" data-test-celum-chip-content [matTooltip]="tooltip() | translate">
  @if (prefixIconConfig()) {
    <celum-icon
      class="celum-chip_prefix-icon"
      [configuration]="prefixIconConfig()"
      [matTooltip]="errorTooltip() | translate"
      [matTooltipDisabled]="!!tooltip()"></celum-icon>
  }
  @if (prefix()) {
    <span class="celum-chip_prefix">{{ prefix() | translate }}</span>
  }
  <span class="celum-chip_text" spaceAwareTooltip [matTooltip]="text() | translate" [matTooltipDisabled]="!!tooltip()">{{ text() | translate }}</span>
</span>
@if (enableClose()) {
  <celum-icon
    class="celum-chip_action-icon"
    data-test-celum-chip-remove-button
    [configuration]="closeIconConfig()"
    [matTooltip]="closeIconTooltip() || 'COMMON.REMOVE' | translate"
    (click)="remove.emit(true)"></celum-icon>
}
